import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Button } from '../Button/index.js';
import Dropdown from '../Dropdown/basic.js';
import '../Dropdown/searchable.js';
import DropdownItem from '../Dropdown/item.js';
import '../Slider/context.js';
import '../Slider/handle.js';
import '../Slider/highlight.js';
import '../Slider/track.js';
import '../Slider/slider.js';
import { RangeSlider } from '../Slider/range-slider.js';
import { RangeSliderNonLinear } from '../Slider/range-slider-non-linear.js';
import { Wrapper } from '../Wrapper/index.js';
import styles from 'ui-components/Filterbar.scss';

var DefaultDropdownSort = function DefaultDropdownSort(_ref) {
  var items = _ref.items,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className;
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement(Dropdown, {
    className: className,
    placeholder: t("FILTER.FILTERBAR.SORT"),
    value: value,
    variant: "dropdownSort",
    onChange: onChange
  }, Array.isArray(items) && items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(DropdownItem, {
      key: item.code,
      value: item.code
    }, item.label);
  }));
};
var Filterbar = function Filterbar(_ref2) {
  var className = _ref2.className,
    filterState = _ref2.filterState,
    openFilters = _ref2.openFilters,
    SortButton = _ref2.SortButton,
    _ref2$sortButtonSide = _ref2.sortButtonSide,
    sortButtonSide = _ref2$sortButtonSide === void 0 ? "left" : _ref2$sortButtonSide,
    _ref2$Button = _ref2.Button,
    Button$1 = _ref2$Button === void 0 ? Button : _ref2$Button,
    _ref2$DropdownSort = _ref2.DropdownSort,
    DropdownSort = _ref2$DropdownSort === void 0 ? DefaultDropdownSort : _ref2$DropdownSort,
    nonLinearSlider = _ref2.nonLinearSlider,
    exponentiation = _ref2.exponentiation,
    _ref2$hidePriceFilter = _ref2.hidePriceFilters,
    hidePriceFilters = _ref2$hidePriceFilter === void 0 ? false : _ref2$hidePriceFilter;
  var t = useTranslate();
  if (!filterState.visible) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className)
  }, /*#__PURE__*/React__default.createElement(Wrapper, {
    className: styles.wrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.block__left
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.item
  }, !hidePriceFilters && /*#__PURE__*/React__default.createElement(Button$1, {
    className: styles.allFiltersButton,
    onClick: openFilters
  }, t("FILTER.FILTERBAR.ALL_FILTERS"), filterState.active.filters.length > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: styles.counter
  }, "(", filterState.active.filters.length, ")")), SortButton && sortButtonSide === "left" ? /*#__PURE__*/React__default.createElement(SortButton, null) : null), filterState.price && filterState.price.max > 0 && filterState.price.min !== filterState.price.max && !hidePriceFilters && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.item, styles.price)
  }, /*#__PURE__*/React__default.createElement("span", null, t("FILTER.FILTERBAR.FILTER_BY_" + (filterState.usePoints ? "POINTS" : "PRICE"))), filterState.price && /*#__PURE__*/React__default.createElement("div", {
    className: styles.slider
  }, nonLinearSlider === true ? /*#__PURE__*/React__default.createElement(RangeSliderNonLinear, {
    variant: "small",
    value: filterState.price.range,
    minValue: filterState.price.min,
    maxValue: filterState.price.max,
    exponentiation: exponentiation,
    onChange: function onChange(x) {
      return filterState.price && filterState.price.setRange(x);
    }
  }) : /*#__PURE__*/React__default.createElement(RangeSlider, {
    variant: "small",
    value: filterState.price.range,
    minValue: filterState.price.min,
    maxValue: filterState.price.max,
    onChange: function onChange(x) {
      return filterState.price && filterState.price.setRange(x);
    }
  })), /*#__PURE__*/React__default.createElement("span", null, filterState.price ? t("FILTER.FILTERBAR.PRICE_RANGE", filterState.price.range) : ""))), SortButton && sortButtonSide === "right" ? /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block__right)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.item
  }, /*#__PURE__*/React__default.createElement(SortButton, null))) : null, !SortButton && filterState.sort.values && filterState.sort.values.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block__right)
  }, /*#__PURE__*/React__default.createElement(DropdownSort, {
    value: filterState.sort.value,
    items: filterState.sort.values,
    onChange: function onChange(v) {
      return filterState.sort.setValue(v);
    }
  }))));
};
var FilterbarHint = function FilterbarHint(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className)
  });
};

export { Filterbar, FilterbarHint };
//# sourceMappingURL=index.js.map
